/**
 * Selects the active tour config for the current environment.
 *
 * There is one config file per environment (tour.config.<env>.ts). This module picks
 * the one matching the running environment. Any tour not listed in that file — or any
 * field left unset — falls back to OFF via TOUR_DEFAULTS.
 */

import { resolveEnv } from '../core/env';
import { config as localhost } from './tour.config.localhost';
import { config as development } from './tour.config.development';
import { config as qa } from './tour.config.qa';
import { config as staging } from './tour.config.staging';
import { config as production } from './tour.config.production';
import type { TourConfig, TourEnvSettings } from './types';

export type { TourConfig, TourEnvSettings };

const BY_ENV: Record<string, TourConfig> = {
  localhost,
  development,
  qa,
  staging,
  production
};

/** Applied when a tour (or a field) is not declared in the active env file. Safe: off. */
export const TOUR_DEFAULTS: Required<TourEnvSettings> = {
  enabled: false,
  autoStart: false,
  startDate: null,
  endDate: null
};

/** The tour config for the current environment (empty ⇒ all tours off). */
export function activeConfig(): TourConfig {
  return BY_ENV[resolveEnv()] ?? {};
}
